import React from 'react';
import { formatDuration, getDate, getStatusColor } from '../history.service';
import {
  activityTypes,
  courseSectionTypeEnum,
  statusEnum
} from '../../../../helper/constants.helper';

const StatusDetails = ({ historyItem }) => {
  return (
    <>
      {historyItem.type === activityTypes.MEETING ? (
        <span className="semi-bold" style={{ color: getStatusColor(historyItem.status) }}>
          {historyItem.status === statusEnum.INITIATED
            ? 'Scheduled'
            : historyItem.status === statusEnum.COMPLETED
              ? 'Completed'
              : historyItem.status === statusEnum.EXPIRED
                ? 'Expired'
                : historyItem.status === statusEnum.CANCELLED
                  ? 'Cancelled'
                  : null}
        </span>
      ) : (
        <span className="semi-bold" style={{ color: getStatusColor(historyItem.status) }}>
          {historyItem.status === statusEnum.INITIATED
            ? 'Initiated'
            : historyItem.status === statusEnum.COMPLETED
              ? 'Completed'
              : historyItem.status === statusEnum.EXPIRED
                ? 'Expired'
                : historyItem.status === statusEnum.CANCELLED
                  ? 'Cancelled'
                  : null}
        </span>
      )}
      &nbsp;&nbsp;
      <span className="semi-bold">{getDate(historyItem.update_time)}</span>
      {historyItem.type === activityTypes.MEETING && (
        <>
          {/* <p className="semi-bold"> {getDate(historyItem.meetingStart)} </p> */}

          <p className="semi-bold"> {historyItem?.locationName} </p>
          {/* <p className="semi-bold"> Paid Online </p> */}
        </>
      )}
      {historyItem.type === activityTypes.HELPLINE && (
        <>
          {/* <p className="semi-bold"> {getDate(historyItem.meetingStart)} </p> */}

          <p className="semi-bold">
            {' '}
            {historyItem?.duration ? formatDuration(historyItem?.duration) : null}{' '}
          </p>
          {/* <p className="semi-bold"> Paid Online </p> */}
        </>
      )}
      {historyItem.type === activityTypes.SELF_ASSESSMENT && (
        <div className="semi-bold">
          {historyItem.key_metrics &&
            historyItem.share_report !== false &&
            historyItem.key_metrics.map((item, index) => {
              return item.key ? (
                <p key={item.key}>
                  {item.key}: {item.value}
                </p>
              ) : null;
            })}
        </div>
      )}
      {historyItem.type === activityTypes.COURSE &&
        historyItem?.sections
          ?.filter((section) => section.type === courseSectionTypeEnum.QUIZ && section.score)
          .map((section, index) => (
            <div className="semi-bold" key={section.id}>
              Score : {section.score}
            </div>
          ))}
      {historyItem.type === activityTypes.COURSE &&
        historyItem?.sections
          ?.filter(
            (section) => section.type === courseSectionTypeEnum.ASSESSMENT && section.key_metrics
          )
          .map((section, index) => (
            <div className="semi-bold" key={section.id}>
              {section?.key_metrics?.map((item, index) => {
                return item.key ? (
                  <p key={item.key}>
                    {item.key}: {item.value}
                  </p>
                ) : null;
              })}
            </div>
          ))}
      <style jsx>
        {`
          .semi-bold {
            font-weight: 500;
          }
        `}
      </style>
    </>
  );
};

export default StatusDetails;
